<!--
 * @Author: your name
 * @Date: 2022-02-16 17:26:57
 * @LastEditTime: 2022-03-15 14:07:24
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /supplier-manage/src/views/register/index.vue
-->
<template>
  <div class="register">
    <div class="page-head">
      <page-head :head-name="headTitle" />
    </div>
    <!-- 拒绝原因，如果有显示并且动态更改页面标题headTitle为申请资料修改 -->
    <div v-if="rejectionReason==true" class="rejection-reason">
      <div class="rejection-icon">
        <img src="@/assets/images/rejection.png" alt="">
      </div>
      <div class="rejection-content">
        <div>您的注册申请已被拒绝！您可以选择 <span>修改</span> 资料再次提交申请！</div>
        <div>拒绝原因：<span>{{ reason }}</span></div>
      </div>
    </div>
    <div class="register-page">
      <div v-if="!rejectionReason && !submissionStatus" class="register-title">
        用户注册页
      </div>
      <div class="registerCcontent" :style="{paddingTop:(rejectionReason==false?'30px':'')}" @click.stop="closeAddress">
        <div v-if="!submissionStatus">
          <div class="title-information">
            <svg-icon icon-class="Enterprise" />
            <span>企业信息 </span>
            <span class="user-jump" @click="toUserRigister">(<span>供应商注册点我跳转</span>)</span>
          </div>
          <el-form
            ref="formLabelAlign"
            :label-position="labelPosition"
            label-width="180px"
            :model="formLabelAlign"
            :rules="rules"
          >
            <el-form-item label="企业名称:" prop="FDemandUnitName">
              <el-input
                v-model="formLabelAlign.FDemandUnitName"
                placeholder="企业名称"
                type="text"
                class="form-item-style"
              />
            </el-form-item>
            <div class="item">
              <el-form-item label="社会统一代码:" prop="FDemandUnitCode">
                <el-input
                  v-model="formLabelAlign.FDemandUnitCode"
                  placeholder="社会统一代码"
                  class="form-item-style"
                />
              </el-form-item>
              <p class="formtext">营业执照信用代码</p>
            </div>
            <el-form-item label="所在区域:" prop="FAreaId">
              <div style="position: relative">
                <div class="address">
                  <div style="width:76%;" @click.stop="changeaddress">
                    <el-input v-model="FAddress" readonly placeholder="请输入内容" />
                  </div>
                  <svg-icon
                    :class="{ 'arrowTransform': !flag, 'arrowTransformReturn': flag }"
                    icon-class="xia"
                    @click.stop="changeaddress"
                  />
                </div>
                <div v-show="flag" class="address-down" @click.stop="abc">
                  <el-tabs ref="elTabs" type="border-card">
                    <el-tab-pane :label="tagAdderr(addressAll)">
                      <div style="width:">
                        <template>
                          <el-tag
                            v-for="(item, index) in addressAll"
                            v-bind="tagColor(item)"
                            @click.stop="addxz1(item.fname, item.fid, index)"
                          >
                            {{ item.fname }}</el-tag>

                        </template>

                      </div>
                    </el-tab-pane>

                    <template v-if="address2.length">
                      <el-tab-pane :label="tagAdderr(address2)">
                        <div style="width:">
                          <template>
                            <el-tag
                              v-for="(item, index) in address2"
                              v-bind="tagColor(item)"
                              @click.stop="addxz2(item.fname, item.fid, index)"
                            >
                              {{ item.fname }}</el-tag>

                          </template>

                        </div>
                      </el-tab-pane>
                    </template>

                    <template v-if="address3.length">
                      <el-tab-pane :label="tagAdderr(address3)">
                        <div style="width:">
                          <template>
                            <el-tag
                              v-for="(item, index) in address3"
                              v-bind="tagColor(item)"
                              @click.stop="addxz3(item.fname, item.fid, index)"
                            >
                              {{ item.fname }}</el-tag>

                          </template>

                        </div>
                      </el-tab-pane>
                    </template>

                    <template v-if="address4.length">
                      <el-tab-pane :label="tagAdderr(address4)">
                        <div style="width:">
                          <template>
                            <el-tag
                              v-for="(item, index) in address4"
                              v-bind="tagColor(item)"
                              @click.stop="addxz4(item.fname, item.fid, index)"
                            >
                              {{ item.fname }}</el-tag>

                          </template>

                        </div>
                      </el-tab-pane>
                    </template>
                  </el-tabs>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="企业地址:" prop="FAddress">
              <el-input
                v-model="formLabelAlign.FAddress"
                placeholder="企业地址"
                type="text"
                style="width:76%"
              />
            </el-form-item>
            <el-form-item label="推荐人:">
              <el-input
                v-model="formLabelAlign.FReferee"
                placeholder="推荐人"
                type="text"
                class="form-item-style"
              />
            </el-form-item>
            <el-form-item label="主营产品:" prop="FProductType">
              <el-input
                v-model="formLabelAlign.FProductType"
                placeholder="主营产品"
                type="text"
                class="form-item-style"
              />
            </el-form-item>
            <el-form-item label="生产规模:" prop="FProductionScale">
              <el-input
                v-model="formLabelAlign.FProductionScale"
                placeholder="生产规模"
                type="text"
                class="form-item-style"
              />
            </el-form-item>
            <el-form-item label="上传营业执照" prop="tureImage" class="changeImage">
              <div style="display:flex">
                <div v-if="formLabelAlign.tureImage" style="display:flex">
                  <div v-for="(item,index) in formLabelAlign.tureImage" :key="index" class="imgbox">
                    <el-image
                      style="width: 60px; height: 60px"
                      :src="item"
                      :preview-src-list="formLabelAlign.tureImage"
                    />
                    <span class="icon el-icon-error" @click.stop="handleRemove(index)" />
                  </div>
                </div>
                <el-upload
                  v-if="formLabelAlign.tureImage.length < 5"
                  ref="upload"
                  v-loading="yyzzLoading"
                  class="avatar-uploader"
                  :show-file-list="false"
                  :auto-upload="false"
                  action="Fake Action"
                  :on-change="handleChange"
                  :before-upload="otherSectionFile"
                  multiple
                  :limit="5"
                >
                  <i
                    class="el-icon-plus avatar-uploader-icon"
                  />
                </el-upload>
              </div>
              <el-dialog :visible.sync="businesslicenseDialogVisible">
                <img class="zsimg" :src="imgUrl" alt="" @click="businesslicenseDialogVisible = false">
              </el-dialog>
            </el-form-item>

            <div class="title-information">
              <svg-icon icon-class="Administrator" />
              <span>管理员信息</span>
            </div>
            <!-- 客户没有开通暂时不展示 -->
            <el-form-item label="手机号:" prop="FPhone">
              <el-input
                v-model="formLabelAlign.FPhone"
                placeholder="请填写注册时提供的手机号"
                type="number"
                class="form-item-style"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="11"
                @blur="FPhoneTest()"
              />
            </el-form-item>
            <!-- <div class="item">
            <el-form-item label="短信验证码:" prop="userCode">
              <el-input
                v-model="formLabelAlign.userCode"
                placeholder="输入验证码"
                class="form-item-style"
              />
            </el-form-item>
            <p
              class="verification-card"
              @click="getCard"
            >
              {{ value }}
            </p>
          </div> -->
            <el-form-item label="姓名:" prop="FDirector">
              <el-input
                v-model="formLabelAlign.FDirector"
                placeholder="姓名"
                type="text"
                class="form-item-style"
              />
            </el-form-item>
            <el-form-item label="设置新密码:" prop="FPassword">
              <el-input
                v-model="formLabelAlign.FPassword"
                placeholder="请输入新密码"
                autocomplete="off"
                type="password"
                class="form-item-style"
              />
            </el-form-item>
            <el-form-item label="确认新密码:" prop="checkPass">
              <el-input
                v-model="formLabelAlign.checkPass"
                placeholder="请再次输入新密码"
                autocomplete="off"
                type="password"
                class="form-item-style"
              />
            </el-form-item>

            <div class="title-information">
              <svg-icon icon-class="Invoicing" />
              <span>开票信息 </span>
            </div>

            <div class="item">
              <el-form-item label="公司名称:" prop="FCompanyName">
                <el-input
                  v-model="formLabelAlign.FCompanyName"
                  placeholder="公司名称"
                  type="text"
                  class="form-item-style"
                />

              </el-form-item>
              <p class="formtext">发票单位名称</p>
            </div>

            <div class="item">
              <el-form-item label="税号:" prop="FTaxNumber">
                <el-input
                  v-model="formLabelAlign.FTaxNumber"
                  placeholder="税号"
                  class="form-item-style"
                />

              </el-form-item>
              <p class="formtext">纳税人识别号</p>
            </div>
            <el-form-item label="地址:" prop="FInvoiceAddress">
              <el-input
                v-model="formLabelAlign.FInvoiceAddress"
                placeholder="地址"
                type="text"
                style="width:76%"
              />
            </el-form-item>

            <el-form-item label="电话" prop="FTelNo">
              <el-input v-model="formLabelAlign.FTelNo" placeholder="电话" class="form-item-style" />
            </el-form-item>
            <el-form-item label="开户行:" prop="FBank">
              <el-input v-model="formLabelAlign.FBank" placeholder="开户行" class="form-item-style" />
            </el-form-item>
            <el-form-item label="手机号:" prop="FFinancialPhone">
              <el-input
                v-model="formLabelAlign.FFinancialPhone"
                placeholder="手机号"
                class="form-item-style"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="11"
                @blur="FFinancialPhoneTest()"
              />
            </el-form-item>
          </el-form>
        </div>
        <div v-if="!rejectionReason && !submissionStatus" class="form-footer" style="margin-bottom:30px">
          <div class="footer-btn">
            <el-button class="use-button" @click="ability(0)">返回</el-button>
            <el-button class="submitbutton" @click="submitForm('formLabelAlign')">
              {{ rejectionReason ? '提交修改' : '提交注册' }}</el-button>
            <el-button class="use-button" @click="ability(1)">在线帮助</el-button>
          </div>
          <el-checkbox v-model="checked">
            <p>我已阅读 <span @click.stop="openagreement(1)">《实达实平台网站服务协议》</span>和 <span
              @click.stop="openagreement(2)"
            >《实达实平台隐私政策》</span></p>
          </el-checkbox>
        </div>

        <!-- 注册资料提交成功 -->
        <div v-if="submissionStatus">
          <div class="tips">
            <div class="icon">
              <img src="@/assets/images/reviewed.png" alt="">
            </div>
            <div class="tipsInfo">
              <p>{{ tipsTest }}</p>
              <p class="samllText"> <span>重要提示：</span> 我们将会尽快审核您的申请，请您耐心等待~</p>
            </div>
          </div>

          <div class="qrcode-view">
            <div class="tip">
              <img src="@/assets/images/tips.png" alt="">
              <div class="tip-text">请扫码关注公众号，方便您后续不在电脑旁能实时收到交易提醒！</div>
            </div>
            <div class="qrcode">
              <div class="img">
                <img src="@/assets/images/qrcode.png" alt="">
              </div>
              <p class="text"> 扫码关注公众号</p>
            </div>
          </div>

          <div class="form-footer">
            <el-button style="margin-top:60px" class="submitbutton" @click="goBack">返回首页</el-button>
          </div>
        </div>

      </div>
    </div>
    <el-dialog
      :title="texttitle==1?'实打实平台用户协议':'实打实平台隐私政策'"
      :visible.sync="agreementChange"
      width="80%"
      class="seeDialog"
    >
      <div>
        <div v-for="(item,index) in openagreementcontent" :key="index" style="margin-bottom: 10px;">
          <div>
            {{ item.fdocTitle }}
          </div>
          <div v-html="item.fdocContent" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { provinceAndCityData, CodeToText } from 'element-china-area-data'
import {
  cityArea,
  register,
  queryArea,
  uploadImg,
  sendMsg,
  getRigistDocTitList,
  getInfo,
  modification
} from '@/api/user'
import debounce from '@/utils/timeout.js'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      let valid = true
      if (value === '') {
        valid = false
        callback(new Error('请输入密码'))
      }
      if (value.length < 8 || value.length > 16) {
        valid = false
        callback(new Error('密码长度为8-16位'))
      }
      if (value.length > 8 || value.length < 16) {
        const reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/
        if (!reg.test(value)) {
          valid = false
          callback(new Error('密码至少包含字母/数字/ 字符两种组合'))
        }
      }
      if (valid) {
        if (this.formLabelAlign.checkPass !== '') {
          this.$refs.formLabelAlign.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formLabelAlign.FPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      tipsTest: '注册资料提交成功，请等待审核结果~',
      labelPosition: 'right',
      checked: false,
      rejectionReason: false, // 是否有拒绝原因
      headTitle: 'Hi~，欢迎注册用户',
      fname: '',
      reason: '',
      submissionStatus: false, // 提交状态，是否显示提交资料成功正在审核画面
      formLabelAlign: {
        // 企业信息
        FProviderUnitName: '',
        FProviderUnitCode: '',
        FDemandUnitName: '', // 企业名称
        FDemandUnitCode: '', // 社会统一代码
        FAreaId: '', // 所在城市
        FAddress: '', // 企业地址
        FReferee: '', // 推荐人
        FProductType: '', // 主营产品
        FProductionScale: '', // 生产规模
        FLicenseImagePath: '', // 营业执照

        tureImage: [],
        // 管理员信息
        FPhone: '', // 手机号
        userCode: '', // 短信验证码
        FDirector: '', // 姓名
        FPassword: '', // 密码

        // 开票信息
        FCompanyName: '', // 公司名称
        FTaxNumber: '', // 税号
        FInvoiceAddress: '', // 地址
        FTelNo: '', // 电话
        FBank: '', // 开户行
        FFinancialPhone: '', // 开票信息手机号
        OperationType: '1'
      },
      checkPass: '', // 确认密码
      businesslicenseDialogVisible: false, // 营业执照图片预览
      // options: provinceAndCityData, // 二级联动不带全部
      selectedOptions: [], // 城市选择
      rules: {
        // 企业信息验证
        FDemandUnitName: [{
          required: true,
          message: '请输入企业名称',
          trigger: 'blur'
        }],
        FDemandUnitCode: [{
          required: true,
          message: '请输入社会统一代码',
          trigger: 'blur'
        }],
        FAreaId: [{
          required: true,
          message: '请选择所在城市',
          trigger: 'blur'
        }],
        FAddress: [{
          required: true,
          message: '请输入企业地址',
          trigger: 'blur'
        }],
        tureImage: [{
          required: true,
          message: '请上传营业执照',
          trigger: 'blur'
        }],
        // 管理员信息验证
        FPhone: [{
          required: true,
          message: '请填写注册时提供的手机号',
          trigger: 'blur'
        },
        {
          max: 11,
          message: '长度为11位数字',
          trigger: 'blur'
        }
        ],
        userCode: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        FDirector: [{
          required: true,
          message: '请输入人员名称',
          trigger: 'blur'
        }],
        FPassword: [{
          required: true,
          validator: validatePass,
          trigger: 'blur'
        }],
        checkPass: [{
          required: true,
          validator: validatePass2,
          trigger: 'blur'
        }],
        // 开票信息
        FCompanyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        FTaxNumber: [{
          required: true,
          message: '请输入税号',
          trigger: 'blur'
        }],
        FInvoiceAddress: [{
          required: true,
          message: '请输入地址',
          trigger: 'blur'
        }],
        FTelNo: [{
          required: true,
          message: '请输入电话',
          trigger: 'blur'
        }],
        FBank: [{
          required: true,
          message: '请输入开户行',
          trigger: 'blur'
        }],
        FFinancialPhone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }]
      },
      listData: {
        pageNo: 1,
        pageSize: 10
      },
      // 储昊明写与供方注册相同
      agreementChange: false,
      openagreementcontent: [],
      texttitle: 1,
      time: 60,
      value: '获取验证码',
      imgUrl: '',
      FAddress: '',
      flag: false,
      address1: [],
      address2: [],
      address3: [],
      address4: [],
      add1: false,
      add2: false,
      add3: false,
      add4: false,
      addname1: {
        fid: null,
        fname: ''
      },
      addname2: {
        fid: null,
        fname: ''
      },
      addname3: {
        fid: null,
        fname: ''
      },
      addname4: {
        fid: null,
        fname: ''
      },
      addressAll: [],
      yyzzLoading: false
      //
    }
  },
  computed: {
    tagColor() {
      return (item) => {
        return item.class ? {
          style: 'color:#fff;', color: '#EC212D'
        } : {
          color: '#fff',
          style: 'color:#000;border:none;'
        }
      }
    },
    tagAdderr() {
      return (arr = []) => {
        const next = arr.find(item => item.class)
        return next ? next.fname : '请选择'
      }
    }
  },
  created() {
    if (this.$route.params.userInfo) {
      this.tipsTest = '修改资料提交成功，请等待审核结果~'
      getInfo(JSON.parse(this.$route.params.userInfo))
        .then(res => {
          if (res.code === 200 && res.result) {
            const u = res.data.userInfo
            const t = this.formLabelAlign
            this.$set(t, 'FDemandUnitName', u.FDemandUnitName)
            this.$set(t, 'FDemandUnitCode', u.FDemandUnitCode)
            this.$set(t, 'FAreaId', u.fareaId)
            this.$set(t, 'FAddress', u.FAddress)
            this.$set(t, 'tureImage', u.FLicenseImagePath.split(','))
            this.$set(t, 'FPhone', u.FPhone)
            this.$set(t, 'FDirector', u.FDirector)
            this.$set(t, 'FPassword', JSON.parse(this.$route.params.userInfo).userPassword)
            this.$set(t, 'checkPass', JSON.parse(this.$route.params.userInfo).userPassword)
            this.$set(t, 'FCompanyName', u.FCompanyName)
            this.$set(t, 'FTaxNumber', u.FTaxNumber)
            this.$set(t, 'FInvoiceAddress', u.FInvoiceAddress)
            this.$set(t, 'FTelNo', u.FTelNo)
            this.$set(t, 'FBank', u.FBank)
            this.$set(t, 'FFinancialPhone', u.FFinancialPhone)
            this.FAddress = u.fareaName
            this.reason = u.frefuseReason
          }
        })
      this.headTitle = '申请资料修改'
      this.rejectionReason = true
    }
    // 省级
    queryArea({
      fid: 0
    }).then(res1 => {
      queryArea({
        fid: res1[0].fid
      }).then(res => {
        this.address1 = res
        this.address1.map(item => {
          item.class = false
        })
        this.addressAll = JSON.parse(JSON.stringify(this.address1))
        this.add1 = true
      })
    })
  },
  mounted() {
    this.cityArea()
  },
  methods: {
    ability(val) {
      if (val) {
        window.open('https://w102.ttkefu.com/k/linkurl/?t=4H7HC6')
      } else {
        window.history.go(-1)
        // this.$router.goBack()
      }
    },
    abc() {
      //   console.log('1')
    },
    toUserRigister() {
      if (window.location.protocol == 'http:') {
        window.open('http://sdssupply.caishen.cn/index.html#/register')
      } else {
        window.open('https://supplier.sds18.com/index.html#/register')
      }
    },
    // 协议展示
    openagreement(val) {
      getRigistDocTitList({
        FDocType: val + 1
      }).then(res => {
        this.openagreementcontent = res
      })
      this.texttitle = val
      this.agreementChange = true
    },
    // 储昊明的验证码
    countdown(t) {
      if (this.time === 0) {
        // 这里时设置当时间到0的时候重新设置点击事件，并且默认time修改为60
        this.time = 60
        this.value = '获取验证码'
        clearInterval(t)
      } else {
        // 这里是显示时间倒计时的时候点击不生效
        this.value = `重新发送(${this.time})`
        this.time--
      }
    },
    getCard() {
      const _this = this
      if (this.time === 60) {
        if (this.formLabelAlign.FPhone.length === 0) {
          this.$message({
            message: '请输入手机号！',
            type: 'warning'
          })
        } else {
          if (!(/^1[34578]\d{9}$/.test(this.formLabelAlign.FPhone))) {
            this.$message({
              message: '请输入正确的手机号！',
              type: 'warning'
            })
          } else {
            // 这里写死了 应该调用获取验证码的接口
            // 按照指定的周期（以毫秒计）来调用函数或计算表达式。
            // 最好是在ajax请求之后再调用函数
            sendMsg({
              telNo: this.formLabelAlign.FPhone
            }).then(res => {
              if (res.result) {
                var t = setInterval(function() {
                  _this.countdown(t)
                }, 1000)

                // 获取验证码成功后调用倒计时函数
                _this.countdown(t)
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      }
    },
    // 图片上传
    handleChange(file, fileList) {
      debounce(() => {
        this.$refs.upload.clearFiles()
        if (fileList.length + this.formLabelAlign.tureImage.length > 5) return this.$message.warning('最多上传5张营业执照')
        this.yyzzLoading = true
        const formData = new FormData()
        fileList.forEach(item => {
          formData.append('file', item.raw)
        })
        const that = this
        uploadImg(formData)
          .then((res) => {
            if (res.error) {
              that.$message.error(res.message)
            } else {
              //   this.formLabelAlign.tureImage.push(res.url)
              res.imgUrlList.forEach(item => {
                if (item.result) {
                  that.formLabelAlign.tureImage.push(item.oriUrl)
                } else {
                  that.$message.error(item.message)
                }
              })
            }
            this.yyzzLoading = false
          })
          .catch(() => {
            this.yyzzLoading = false
            this.$message.error('上传失败')
          })
      }, 100)
      //   const formData = new FormData()
      //   formData.append('file', file.raw)
      //   const that = this
      //   setTimeout(function() {
      //     uploadImg(formData).then((res) => {
      //       if (res.result) {
      //         //   this.formLabelAlign.tureImage.push(res.url)
      //         res.imgUrlList.forEach(item => {
      //           if (item.result) {
      //             that.formLabelAlign.tureImage.push(item.url)
      //           }
      //         })
      //       }
      //     })
      //   }, 200)
    },
    handleRemove(index) {
      this.formLabelAlign.tureImage.splice(index, 1)
    },
    otherSectionFile(file, fileList) {
      this.uploadDisabled = fileList.length >= this.limit
      const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg']
      const isJPG = typeArr.indexOf(file.raw.type) !== -1
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('只能是图片!')
        this.$refs.upload.clearFiles()
        // this.otherFiles = null
        return
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
        this.$refs.upload.clearFiles()
        // this.otherFiles = null
        return
      }
      // console.log(file.raw)
      // this.otherFiles = file.raw
    },
    //  储昊明地址列表
    addxz1(fadd, fid, index) {
      this.addname1.fname = fadd
      this.addname2.fname = ''
      this.addname3.fname = ''
      this.addname4.fname = ''
      this.addname1.fid = fid
      this.addname2.fid = null
      this.addname3.fid = null
      this.addname4.fid = null
      this.address1.map(item => {
        item.class = false
      })
      this.addressAll.map(item => {
        item.class = false
      })
      this.addressAll[index].class = true
      this.address3 = []
      this.address4 = []
      queryArea({
        fid: fid
      }).then(res => {
        if (res.length === 0) {
          this.FAddress = this.addname1.fname
          this.formLabelAlign.FAreaId = this.addname1.fid
          this.$refs['formLabelAlign'].validateField('FAreaId')
          this.add1 = true
          this.add2 = false
          this.add3 = false
          this.add4 = false
          this.flag = false
          this.address2 = []
        } else {
          this.address2 = res
          this.address2.map(item => {
            item.class = false
          })
          this.add1 = true
          this.add2 = true
          this.add3 = false
          this.add4 = false
          this.$refs.elTabs.currentName = '1'
        }
      })
    },
    // 市
    addxz2(fadd, fid, index) {
      this.addname2.fname = fadd
      this.addname3.fname = ''
      this.addname4.fname = ''
      this.addname2.fid = fid
      this.addname3.fid = null
      this.addname4.fid = null
      // this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname
      this.address2.map(item => {
        item.class = false
      })
      this.address2[index].class = true
      this.address4 = []
      queryArea({
        fid: fid
      }).then(res => {
        if (res.length === 0) {
          this.FAddress = this.addname1.fname + '/' + this.addname2.fname
          this.formLabelAlign.FAreaId = this.addname2.fid
          this.$refs['formLabelAlign'].validateField('FAreaId')
          this.add1 = true
          this.add2 = true
          this.add3 = false
          this.add4 = false
          this.flag = false
        } else {
          this.address3 = res
          this.address3.map(item => {
            item.class = false
            this.add1 = true
            this.add2 = true
            this.add3 = true
            this.add4 = false
          })
          this.$refs.elTabs.currentName = '2'
        }
      })
    },
    // 县
    addxz3(fadd, fid, index) {
      this.addname3.fname = fadd
      this.addname4.fname = ''
      this.addname3.fid = fid
      this.addname4.fid = null
      this.address3.map(item => {
        item.class = false
      })
      this.address3[index].class = true
      queryArea({
        fid: fid
      }).then(res => {
        if (res.length === 0) {
          this.FAddress = this.addname1.fname + '/' + this.addname2.fname + '/' + this.addname3.fname
          this.formLabelAlign.FAreaId = this.addname3.fid
          this.$refs['formLabelAlign'].validateField('FAreaId')
          this.add1 = true
          this.add2 = true
          this.add3 = true
          this.add4 = false
          this.flag = false
        } else {
          this.address4 = res
          this.address4.map(item => {
            item.class = false
          })
          this.add1 = true
          this.add2 = true
          this.add3 = true
          this.add4 = true
          this.$refs.elTabs.currentName = '3'
        }
      })
    },
    // 街道
    addxz4(fadd, fid, index) {
      this.addname4.fname = fadd
      this.addname4.fid = fid
      this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname + '/' + this.addname3
        .fname + '/' + this.addname4.fname
      this.address4.map(item => {
        item.class = false
      })
      this.address4[index].class = true
      this.flag = false
      this.$forceUpdate()
    },
    closeAddress() {
      if (this.address2.length && this.addname2.fid == null) return
      if (this.address3.length && this.addname3.fid == null) return
      this.flag = false
    },
    // 地址点击事件
    changeaddress() {
      if (this.flag && this.address2.length && this.addname2.fid == null) return
      if (this.flag && this.address3.length && this.addname3.fid == null) return
      this.flag = !this.flag
      this.$refs.elTabs.currentName = '0'
    },
    //  获取列表
    async cityArea() {
      const {
        records
      } = await cityArea(this.listData)
      this.selectedOptions = records
    },
    // 手机号验证
    FFinancialPhoneTest() {
      // 验证手机号
      const reg = /1[0-9]{10}/g
      if (this.formLabelAlign.FFinancialPhone === '' || this.formLabelAlign.FFinancialPhone.length <= 10 || !reg.test(this.formLabelAlign.FFinancialPhone)) {
        this.$message.error('请输入正确的手机号')
        this.formLabelAlign.FFinancialPhone = ''
        return false
      }
    },
    FPhoneTest() {
      const reg = /1[0-9]{10}/g
      if (this.formLabelAlign.FPhone === '' || this.formLabelAlign.FPhone.length <= 10 || !reg.test(this
        .formLabelAlign.FPhone)) {
        this.$message.error('请输入正确的手机号')
        this.formLabelAlign.FPhone = ''
        return false
      }
    },
    // 删除营业执照照片
    businessLicenseRemove(file, fileList) {
      //   console.log(file, fileList)
    },
    // 预览营业执照照片
    businessLicensePreview(url) {
      this.imgUrl = url
      this.businesslicenseDialogVisible = true
    },

    selectCityArea(e) {
      this.formLabelAlign.FAreaId = e
    },
    submitForm(formname) {
      if (this.yyzzLoading) return this.$message.warning('请等待图片上传完成')
      this.$refs[formname].validate((valid) => {
        if (valid) {
          if (this.checked) {
            this.getSubmitFormData()
          } else {
            this.$message({
              message: '请阅读并同意协议',
              type: 'warning'
            })
          }
        } else {
          //   console.log('error submit!!')
          return false
        }
      })
    },
    async getSubmitFormData() {
      const loadingObj = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.5)',
        target: document.querySelector('.submit-test-dialog')
      })
      setTimeout(() => {
        loadingObj.close()
      }, 5000)
      this.formLabelAlign.FLicenseImagePath = this.formLabelAlign.tureImage.toString()
      let res
      if (this.$route.params.userInfo) {
        res = await modification(this.formLabelAlign)
      } else {
        res = await register(this.formLabelAlign)
      }
      if (res.code === 200) {
        this.submissionStatus = true
        loadingObj.close()
      } else {
        console.log(123)
        // this.formLabelAlign.tureImage = this.formLabelAlign.tureImage.split(',')
        loadingObj.close()
        this.$message.error('注册失败!')
        console.log(456)
      }
    },
    goBack() {
      this.$router.push({
        path: '/Home'
      }) // 返回上一页
    }
  }
}
</script>

<style lang="scss">
    .register {
        .register-page {
            background-color: #F3F3F3;

            >div {
                width: 64%;
                min-width: 1000px;
                margin: 0 auto;
            }

            .register-title {
                height: 66px;
                line-height: 26px;
                font-size: 20px;
                font-weight: bold;
                color: #333333;
                padding: 20px 0;
            }
        }

        .page-head {
            width: 100%;
            background-color: #fff;

            .head {
                width: 64%;
                min-width: 1000px !important;
                margin: 0 auto;
                box-shadow: none;

                .head-left {
                    padding-left: 0;
                }
            }
        }

        .seeDialog {
            .el-dialog__body {
                min-height: 450px;
                max-height: 450px;
                overflow-y: scroll;
            }
        }

        .registerCcontent {
            min-width: 90%;
            min-height: 88vh;
            margin: 1px 5% 0 5%;
            background: #fff;
            z-index: 1;
            display: flex;
            flex-direction: column;
            // align-items: center;
            box-sizing: border-box;
            padding: 0 70px;

            .el-form-item__label {
                color: #333;
                font-weight: 400;
            }

            // justify-content: center;
            .verification-card {
                font-size: 12px;
                font-family: SimSun;
                height: 30px;
                width: 80px;
                border-radius: 4px;
                text-align: center;
                line-height: 30px;
                font-weight: 400;
                color: #3b84d7;
                margin-left: 10px;
                margin-bottom: 25px;
                border: 1px solid #3b84d7;
            }

            //
            .address {
                position: relative;
                width: 100%;

                .el-input {
                    width: 100%;
                }

                .arrowTransform {
                    position: absolute;
                    right: calc(24% + 20px);
                    top: 12px;
                    transition: 0.2s;
                    transform-origin: center;
                    transform: rotateZ(180deg);
                }

                .arrowTransformReturn {
                    position: absolute;
                    right: calc(24% + 20px);
                    top: 12px;
                    transition: 0.2s;
                    transform-origin: center;
                    transform: rotateZ(0deg);
                }

            }

                            .address-down {
                    position: absolute;
                    top: 36px;
                    left: 0px;
                    z-index: 1000;
                    display: flex;
                    margin: 5px 0;
                    font-size: 14px;
                    background: #fff;
                    border: 1px solid #e4e7ed;
                    border-radius: 4px;
                    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
                    overflow: auto;

                    width: 76%;

                    .el-tabs__item {
                        height: 32px;
                        line-height: 32px;
                    }

                    .el-tabs__header {
                        height: auto;
                    }

                    .el-tabs__header .el-tabs__nav {
                        width: auto;
                    }

                    .el-tabs__header .el-tabs__nav-scroll,
                    .el-tabs__header .el-tabs__nav,
                    .el-tabs__header .el-tabs__nav-wrap {
                        line-height: normal;
                        height: auto;
                    }

                    .el-tag {
                        padding: 0 7px;
                        line-height: 26px;
                        height: 26px;
                        margin: 0 5px;
                        cursor: pointer;
                        min-width: 52px;
                    }

                    .el-tag:hover {
                        background-color: #EC212D !important;
                        color: #fff !important;
                    }

                    .el-tabs__item {
                        color: #000;
                    }

                    .is-top .is-active {
                        background-color: #EC212D !important;
                        color: #fff !important;
                    }

                    .el-tabs--border-card>.el-tabs__content {
                        padding: 8px;
                    }

                    .add {
                        overflow-y: auto;
                        height: 170px;
                        width: 185px;

                        .box {
                            position: relative;
                            display: flex;
                            align-items: center;
                            padding-left: 10px;
                            padding-right: 30px;
                            height: 34px;
                            line-height: 34px;
                            outline: none;

                            .el-icon-arrow-right {
                                position: absolute;
                                right: 10px;
                            }
                        }

                        .box-blue {
                            color: skyblue;
                            position: relative;
                            display: flex;
                            align-items: center;
                            padding-left: 10px;
                            padding-right: 30px;
                            height: 34px;
                            line-height: 34px;
                            outline: none;

                            .el-icon-arrow-right {
                                position: absolute;
                                right: 10px;
                            }
                        }
                    }
                }

            //
            .item {
                position: relative;
                display: flex;
                align-items: center;
                // justify-content: center;
            }

            .form-footer {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .footer-btn {
                    margin-top: 24px;
                    display: flex;
                }

                .el-checkbox {
                    height: 60px;
                    line-height: 60px;
                }

                p {
                font-size: 12px;
                font-family: SimSun;
                font-weight: 400;
                color: #333333;

                span {
                    color: #EC2227;
                }
                }
            }

            .el-form-item {
                width: 100%;
                margin-bottom: 22px;
            }

            .submitbutton {
                width: 220px;
                height: 40px;
                background: #EC2227;
                border-radius: 2px;
                color: #fff;
                border: none;
                margin: 0 32px;
            }

            .use-button {
                width: 141px;
                height: 40px;
                border-color: #EC2227;
                color: #EC2227;
                border-radius: 0;
                margin: 0;
            }

            .title-information {
                width: 100%;
                height: 50px;
                display: flex;
                align-items: center;
                margin-bottom: 18px;
                border-bottom: 1px solid #EBEBEB;

                span {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333;
                    margin-left: 10px;
                }

                .user-jump {
                    cursor: pointer;
                    margin-left: 20px;
                    color: #EC212D;

                    span {
                        color: #EC212D;
                        margin-left: 0;
                        text-decoration: underline;
                    }
                }
            }

            .formtext {
                height: 40px;
                line-height: 40px;
                position: absolute;
                top: 0;
                left: calc(76% + 80px);
                font-size: 12px;
                font-family: SimSun;
                font-weight: 400;
                color: #999999;
                margin: 0px;
            }

            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none !important;
            }

            input[type="number"] {
                -moz-appearance: textfield;
            }

            .el-input {
                width: 76%;
                // height: 40px;
            }

            .tips {
                width: 100%;
                height: 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;

                .icon {
                    width: 110px;
                    height: 96px;
                    margin-right: 30px;
                }

                .tipsInfo {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;

                    .samllText {
                        font-size: 14px;
                        font-family: SimSun;
                        font-weight: 400;
                        color: #666666;
                        margin-top: 30px;

                        span {
                            font-size: 14px;
                            font-family: Adobe Heiti Std;
                            font-weight: normal;
                            color: #EC212D;
                        }
                    }
                }
            }

            .qrcode-view {
                width: 100%;
                height: 150px;
                display: flex;
                justify-content: flex-end;
                margin-top: 100px;

                .tip {
                    width: 186px;
                    height: 80px;
                    margin: 20px 25px 0 0;
                    position: relative;

                    .tip-text {
                        font-size: 12px;
                        font-family: SimSun;
                        font-weight: 400;
                        color: #EC9821;
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        box-sizing: border-box;
                        padding: 13px 32px 15px 23px;
                        line-height: 20px;
                    }
                }

                .qrcode {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .img {
                        width: 80px;
                        height: 80px;
                    }

                    .text {
                        font-size: 12px;
                        font-family: SimSun;
                        font-weight: 400;
                        color: #333333;
                    }
                }
            }

            //
            .el-dialog__wrapper {
                .el-dialog {
                    height: 50px;
                    width: 50px;
                    overflow: none;

                    .zsimg {
                        width: 500px;
                        height: 500px;
                        left: -220px;
                        top: -240px;
                        position: absolute;
                    }
                }
            }

            .avatar-uploader {
                height: 62px;
            }

            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .avatar-uploader .el-upload:hover {
                border-color: #409eff;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 60px;
                height: 60px;
                line-height: 60px;
                text-align: center;
            }

            .imgbox {
                position: relative;
                margin-bottom: 10px;
                margin-right: 10px;

                .avatar {
                    width: 60px;
                    height: 60px;
                    margin-right: 10px;
                }

                .icon {
                    position: absolute;
                    top: 3px;
                    right: 0px;
                    color: red;
                }
            }
        }

        //
        .rejection-reason {
            width: 100%;
            height: 100px;
            background: #EC212D;
            box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);
            position: relative;
            top: 0;
            left: 0;
            right: 0;
            box-sizing: border-box;
            padding: 19px 0 19px 183px;
            display: flex;
            align-items: center;

            .rejection-icon {
                width: 57px;
                height: 65px;
                margin-right: 29px;
            }

            .rejection-content {
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 24px;
            }

            .rejection-content div:first-child {
                display: flex;
                align-items: center;

                span {
                    width: 56px;
                    height: 28px;
                    background: #F5F5F5;
                    box-shadow: 0px 3px 7px 0px rgba(142, 22, 29, 0.2);
                    border-radius: 2px;
                    margin: 0 10px;
                    font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #EC212D;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .rejection-content div:nth-child(2) {
                margin-top: 13px;

                span {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #FFFFFF;
                }
            }

        }
    }
</style>
